<template>
  <master-main
    :addProperties="{
      isWizard: false,
    }"
    :exportProperties="{
      pdf: {
        filename: `${$t('calibration.calibration')}_${dateToday}.pdf`,
        route: `${getModuleRoute}/pdf`,
        showPDFButton: false,
      },
      xls: {
        filename: `${$t('calibration.calibration_type')}_${dateToday}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :dataBadges="[
      {
        columnLabel: $t('common_words.associated_companies2'),
        data: 'businesses',
        property: 'name',
        minWidth: 180,
      },
    ]"
    :route="getModuleRoute"
    :showProperties="showProperties"
    :tableProperties="tableProperties"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
    <template slot="dialogForm">
      <edit-or-create-calibration-type
        v-if="renderComponent"
        :syncDialog="modals"
        @addEdit="addEdit"
        @closeModal="handleCloseModal"
        @showHideLoading="showHideLoading"
        @showNotification="notifyVue"
        ref="editCreate"
      />
    </template>
  </master-main>
</template>
<script>
import { getDateToday } from 'src/util/Util';
import CalibrationTypeTable from 'src/views/Pages/Dashboard/Calibration/CalibrationType/calibration-type-table.js';
import EditCreate from 'src/views/Pages/Dashboard/Calibration/CalibrationType/EditCreate.vue';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinRerender from 'src/mixins/mixin-rerender';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';
import { MixinExport } from 'src/mixins/mixin-export';

export default {
  components: { MasterMain, [EditCreate.name]: EditCreate },
  data() {
    return {
      tableProperties: {},
      showProperties: { size: '70%' },
    };
  },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinForm,
    MixinMain,
    MixinPermissions,
    MixinWithDialog,
    MixinRerender,
    MixinMenu,
    MixinExport,
  ],
  computed: {
    getModuleRoute() {
      return 'calibration/calibrationtypes';
    },
    buildTableProperties() {
      return {
        tableColumns: [...CalibrationTypeTable().tableColumns],
        model: 'calibrationtypes',
        effectTags: 'dark',
        defaultSort: { prop: 'name', order: 'ascending' },
      };
    },
    dateToday() {
      return getDateToday();
    },
  },
};
</script>
